import { memo, useState } from 'react'

import { IContact } from 'clickNgo/entities/contact'

import { ReassignRolesStep, WelcomeStep } from './components/steps'
import { BackupContactStep } from './components/steps/backupContactStep'
import { CompletionStep } from './components/steps/completionStep'
import { ReassignFlagsStep } from './components/steps/reassignFlagsStep'
import { ContactDeactivationStep } from './configs'

type Props = {
  onClose: () => void
  onDeactivate: (deactivatedContact: IContact) => void
}

export const ContactDeactivationModalContent = memo<Props>(({ onClose, onDeactivate }) => {
  const [currentStep, setCurrentStep] = useState<ContactDeactivationStep>(
    ContactDeactivationStep.Welcome
  )

  switch (currentStep) {
    case ContactDeactivationStep.Welcome: {
      return <WelcomeStep onProceed={setCurrentStep} onCancel={onClose} />
    }
    case ContactDeactivationStep.ReassignRoles: {
      return <ReassignRolesStep onProceed={setCurrentStep} onCancel={onClose} />
    }
    case ContactDeactivationStep.ReassignFlags: {
      return <ReassignFlagsStep onProceed={setCurrentStep} onCancel={onClose} />
    }
    case ContactDeactivationStep.Backup:
      return <BackupContactStep onProceed={setCurrentStep} onCancel={onClose} />
    case ContactDeactivationStep.Completion: {
      return <CompletionStep onDeactivate={onDeactivate} onCancel={onClose} />
    }
    default:
      return null
  }
})

ContactDeactivationModalContent.displayName = 'ContactDeactivationModalContent'
